import { InputElement } from '@chakra-ui/react'
import { Group, GroupProps } from '@chakra-ui/react/group'
import * as React from 'react'

type InputGroupProps = GroupProps & {
  startElement?: React.ReactNode
  startElementProps?: React.ComponentProps<typeof InputElement>
  endElement?: React.ReactNode
  endElementProps?: React.ComponentProps<typeof InputElement>
  startOffset?: string
  endOffset?: string
  children: React.ReactElement
}

export const InputGroup = React.forwardRef(function InputGroup(props: InputGroupProps, ref: React.Ref<HTMLDivElement>) {
  const {
    startElement,
    startElementProps,
    endElement,
    endElementProps,
    children,
    startOffset = '6px',
    endOffset = '6px',
    ...rest
  } = props

  const child = React.Children.only(children)

  return (
    <Group ref={ref} {...rest}>
      {startElement && (
        <InputElement pointerEvents="none" {...startElementProps}>
          {startElement}
        </InputElement>
      )}
      {React.cloneElement(child, {
        ...(startElement && {
          ps: `calc(var(--input-height) - ${startOffset})`,
        }),
        ...(endElement && { pe: `calc(var(--input-height) - ${endOffset})` }),
        ...(typeof children.props === 'object' ? children.props : {}),
      })}
      {endElement && (
        <InputElement placement="end" {...endElementProps}>
          {endElement}
        </InputElement>
      )}
    </Group>
  )
})
